import AppPage from '../../mixins/app-page'

import AppCasesFilter from '../app-cases-filter'
import AppTextLinesSeparated from '../app-text-lines-separated'

import getAbsoluteBoundingRect from '../../utils/getAbsoluteBoundingRect'
import { getSafe } from '../../utils/Object'
import { clamp } from '../../utils/Number'
import { arraysHaveTheSameValues } from '../../utils/Array'

export default
{
    name: 'page-home',

    mixins:
    [
        AppPage
    ],

    components:
    {
        AppCasesFilter,
        AppTextLinesSeparated
    },

    data()
    {
        return {
            news: this.$root.content.news.entries[0],
            cases: [],
            activeSectionID: 0,
            sectionFiltersIsVisible: false,
            activeCasesID: [],
            activeCasesReseted: false,
            isAnimated: false,
            isComingBackToSection: false,
            videosCanBePlayed: [],
            _casesVideosContainerRect: [],
            caseCategoryHidden: [],
            progressBarIsHidden: false,
            assetsToLoad: 0,
            assetsLoaded: 0
        }
    },

    watch:
    {
        activeSectionID: 'onActiveSectionIDChange',
        sectionFiltersIsVisible: 'onSectionFiltersIsVisibleChange'
    },

    created()
    {
        // Get events
        this.eventHub.$on('application:keydown', this._onKeydown)
        this.eventHub.$on('window:raf', this._onEnterFrame)
        this.eventHub.$on('window:resize', this._onResize)
        this.eventHub.$on('page-home:show-filters-section', this._showSectionFilters)
        this.eventHub.$on('page-home:refresh-filter', this._refreshNewFilters)
        this.eventHub.$on('page-home:hide-filters', this._hideSectionsFilters)

        this.eventHub.$emit('app-header:hide-header')

        // Mousewheel
        this.PIXEL_STEP = 10
        this.LINE_HEIGHT = 40
        this.PAGE_HEIGHT = this.$root.height

        this._isWheeling = false
        this._isPointerDown = false
        this._pointerX = 0
        this._pointerY = 0
        this._pointerStartX = 0
        this._pointerStartY = 0
        this._goingBackToNews = false
        //

        // Varaibles
        this._heightToSoustract = 0

        this.$casesVideos = []
        this._casesVideosContainerRect = []

        // Looking if there are some filters
        if (getSafe(() => this.$route.query.categorie))
        {
            // Get cases who have this filtered category
            this._getCases(this.$route.query.categorie)
        }
        else
        {
            this._getCases()

            // Replace URL
            this.$router.replace(this.$root.getPageURLFromName('home'))
        }
    },

    mounted()
    {
        this.eventHub.$emit('app-header:change-color', 'white')
        this.eventHub.$emit('app-header:hide-filter')

        this._getDOMElements()
        this._loadImages(() =>
        {
            this._onResize()
            this._loadVideos()
        })

        if (this.$root.homeLastSection !== 0)
        {
            this.isComingBackToSection = true

            setTimeout(() =>
            {
                this.isComingBackToSection = false
            }, 1000)
        }

        this._changeSectionIDTo(this.$root.homeLastSection)
    },

    destroyed()
    {
        // Destroy events
        this.eventHub.$on('application:keydown', this._onKeydown)
        this.eventHub.$off('window:raf', this._onEnterFrame)
        this.eventHub.$off('window:resize', this._onResize)
        this.eventHub.$off('page-home:show-filters-section', this._showSectionFilters)
        this.eventHub.$off('page-home:refresh-filter', this._refreshNewFilters)
        this.eventHub.$off('page-home:hide-filters', this._hideSectionsFilters)
    },

    methods:
    {
        // EVENTS
        _onKeydown(event)
        {
            if (this.sectionFiltersIsVisible
                && event.keyCode === 27)
            {
                this._hideSectionsFilters()
            }

            if (this.activeSectionID !== 2)
            {
                if ([37, 38].indexOf(event.keyCode) !== -1) this._onPreviousSection()
                else if ([32, 39, 40].indexOf(event.keyCode) !== -1) this._onNextSection()
            }
            else if (this.$root.smoothScroll <= 5
                && [37, 38].indexOf(event.keyCode) !== -1)
            {
                this._onPreviousSection()
            }
        },

        _onEnterFrame()
        {
            this._getActiveCases()

            if (this._casesCategoryRect
                && this._casesCategoryRect.length > 0
                && this.$root.width <= 2020 /* magic number */
                && this.$root.width > this.$root.breakpoints.sm)
            {
                for (let i = 0; i < this._casesCategoryRect.length; i += 1)
                {
                    const rect = this._casesCategoryRect[i]
                    const category = this.$casesCategory[i]

                    if (this.$root.smoothScroll + 75 >= rect.top)
                    {
                        category.classList.add('is-hidden')
                    }
                    else
                    {
                        category.classList.remove('is-hidden')
                    }
                }
            }
        },

        _onResize()
        {
            if (this.$logotype) this._logotypeRect = getAbsoluteBoundingRect(this.$logotype)

            if (this.$containerBackground) this._containerBackgroundRect = getAbsoluteBoundingRect(this.$containerBackground)

            if (this.$containerNews) this._containerNewsRect = getAbsoluteBoundingRect(this.$containerNews)

            if (this.$newsTitle) this._newsTitleRect = getAbsoluteBoundingRect(this.$newsTitle)

            if (this.$sections)
            {
                this._sectionsRect = []

                for (let i = 0; i < this.$sections.length; i += 1)
                {
                    this._sectionsRect.push(getAbsoluteBoundingRect(this.$sections[i]))
                }
            }

            if (this.$casesVideosContainer
                && this.$sectionsCases)
            {
                this._sectionCasesRect = getAbsoluteBoundingRect(this.$sectionsCases)
                this._casesVideosContainerRect = []
                this._casesVideosContainerRect.length = 0

                this.assetsToLoad += this.$casesVideos.length

                if (this.$casesVideosContainer.length > 0
                    && !this.$root.isTouch)
                {
                    for (let i = 0; i < this.$casesVideosContainer.length; i += 1)
                    {
                        const rect = getAbsoluteBoundingRect(this.$casesVideosContainer[i])

                        if (i === 0)
                        {
                            if (rect.top > this.$root.height * 3) this._heightToSoustract = this.$root.height * 3
                            else if (rect.top > this.$root.height * 2) this._heightToSoustract = this.$root.height * 2
                            else if (rect.top > this.$root.height) this._heightToSoustract = this.$root.height
                        }

                        if (this.activeSectionID !== 2) rect.top -= this._heightToSoustract

                        this._casesVideosContainerRect[i] = rect
                        this.assetsLoaded += 1

                        if (this.assetsLoaded === this.assetsToLoad)
                        {
                            this._playActiveCasesVideos()

                            setTimeout(() =>
                            {
                                this.progressBarIsHidden = true

                                this.eventHub.$emit('page:enable-scroll')
                                this.eventHub.$emit('app-header:show-header')
                            }, 1000 /* transition-duration on p-home__landing__loader */)
                        }
                    }
                }
                else
                {
                    setTimeout(() =>
                    {
                        this.progressBarIsHidden = true

                        this.eventHub.$emit('page:enable-scroll')
                        this.eventHub.$emit('app-header:show-header')
                    }, 1000 /* transition-duration on p-home__landing__loader */)
                }
            }

            if (this.$casesCategory)
            {
                this._casesCategoryRect = []
                this._casesCategoryRect.length = 0

                for (let i = 0; i < this.$casesCategory.length; i += 1)
                {
                    const category = this.$casesCategory[i]
                    this._casesCategoryRect[i] = getAbsoluteBoundingRect(category)
                }
            }

            // this._scaleAndTranslateLogotype()
        },

        _loadImages(callback)
        {
            const images = this.$el.querySelectorAll('img')
            this.assetsToLoad += images.length

            for (let i = 0; i < images.length; i += 1)
            {
                const image = images[i]

                const xhr = new XMLHttpRequest()
                xhr.open('GET', image.getAttribute('src'), true)

                xhr.onload = () =>
                {
                    if (xhr.status === 200)
                    {
                        this.assetsLoaded += 1

                        if (this.assetsLoaded === this.assetsToLoad
                            && callback)
                        {
                            callback()
                        }
                    }
                }

                xhr.send()
            }
        },

        _loadVideos()
        {
            for (let i = 0; i < this.$casesVideos.length; i += 1)
            {
                const video = this.$casesVideos[i]
                video.src = ''

                const xhr = new XMLHttpRequest()
                xhr.open('GET', this.$root.CONFIG.env.uploads + this.cases[i].cover.path, true)
                xhr.responseType = 'blob'

                // xhr.onprogress = event =>
                // {
                //     if (event.lengthComputable)
                //     {
                //         const percent = ((event.loaded / event.total) * 100 | 0) + '%'
                //     }
                // }

                xhr.onload = () =>
                {
                    if (xhr.status === 200)
                    {
                        this.videosCanBePlayed.push(i)
                        video.src = URL.createObjectURL(xhr.response)
                    }
                }

                xhr.send()

                // video.onprogress = () =>
                // {
                //     console.log(i)
                // }
                //
                // video.load()

                // video.onloadeddata = () =>
                // {
                //     this.$nextTick(() =>
                //     {
                //         this.videosCanBePlayed.push(i)
                //         console.log('loaded ' + i, this.videosCanBePlayed.length + ' / ' + this.$casesVideos.length)
                //     })
                // }
            }
        },

        // WATCHERS
        onActiveSectionIDChange()
        {
            this.$root.homeLastSection = this.activeSectionID

            if (this.activeSectionID === 2)
            {
                this.eventHub.$emit('app-header:change-color', 'black')

                this.eventHub.$emit('app-header:show-filter')

                if (this.$root.homeLastSectionScrollTop <= 5) this.$root.scrollTo(1, true)

                setTimeout(() =>
                {
                    this.$root.$container.classList.remove('u-fit-v')
                    this.$root.$container.classList.remove('u-overflow-h')
                    this.$root.$container.classList.add('u-fit-w')
                }, 1000)
            }
            else
            {
                this.eventHub.$emit('app-header:change-color', 'white')

                this.eventHub.$emit('app-header:hide-filter')

                this.$root.$container.classList.add('u-fit-v')
                this.$root.$container.classList.add('u-overflow-h')
                this.$root.$container.classList.remove('u-fit-w')
            }

            for (let i = 0; i < this.$sections.length; i += 1)
            {
                const section = this.$sections[i]
                section.style.transform = `translateY(${this.$root.height * this.activeSectionID * -1}px) translateZ(0)`
            }

            // this._scaleAndTranslateLogotype()
        },

        onSectionFiltersIsVisibleChange()
        {
            if (this.sectionFiltersIsVisible)
            {
                for (let i = 0; i < this.$casesVideos.length; i += 1)
                {
                    this.$casesVideos[i].pause()
                }
            }
        },

        // GETTERS
        _getDOMElements()
        {
            this.$logotype = this.$el.querySelector('.js-ig-logo')
            this.$containerBackground = this.$el
            this.$containerNews = this.$el.querySelector('.js-news-container')

            this.$newsTitle = this.$el.querySelector('.js-news-title')

            this.$sections = this.$el.querySelectorAll('.js-section')
            this.$sectionsCases = this.$el.querySelector('.js-section-cases')

            this.$casesVideos = this.$el.querySelectorAll('.js-case-video')
            this.$casesVideosContainer = this.$el.querySelectorAll('.js-case-video-container')
            this.$casesCategory = this.$el.querySelectorAll('.js-case-category')
        },

        _getActiveCases()
        {
            if (this._casesVideosContainerRect
                && this._casesVideosContainerRect.length > 0)
            {
                const activeCasesIDBackUp = this.activeCasesID.slice(0)
                if (this.activeSectionID === 2
                    && !this.sectionFiltersIsVisible)
                {
                    let thereIsActiveCase = false
                    for (let i = 0; i < this._casesVideosContainerRect.length; i += 1)
                    {
                        const c = this._casesVideosContainerRect[i]

                        if (c &&
                            this.$root.smoothScroll + this.$root.height >= c.top + (c.height / 3 * 1)
                            && this.$root.smoothScroll <= c.top + c.height - (c.height / 3 * 1)
                            && this.videosCanBePlayed.indexOf(i) !== -1)
                        {
                            if (this.activeCasesID.indexOf(i) === -1)
                            {
                                this.activeCasesID.push(i)
                            }

                            thereIsActiveCase = true
                        }
                        else if (this.activeCasesID.indexOf(i) !== -1)
                        {
                            this.activeCasesID.splice(this.activeCasesID.indexOf(i), 1)
                        }
                    }

                    if (!thereIsActiveCase) this.activeCasesID = []

                    this.activeCasesID = this.activeCasesID.sort()
                }
                else if (this.activeCasesID.length > 0
                    && !this.activeCasesReseted)
                {
                    this.activeCasesReseted = true

                    setTimeout(() =>
                    {
                        this.activeCasesID = []
                        this.activeCasesID.length = 0

                        this.activeCasesReseted = false
                    }, 0)
                }

                if (!arraysHaveTheSameValues(activeCasesIDBackUp, this.activeCasesID))
                {
                    this._playActiveCasesVideos()
                }
            }
        },

        // ACTIONS
        // _scaleAndTranslateLogotype()
        // {
        //     if (this.activeSectionID === 0
        //         && this.$logotype)
        //     {
        //         this.$logotype.style.transform = 'translateY(0) scale(1) translateZ(0)'
        //     }
        //     else if (this._newsTitleRect
        //         && this.$logotype
        //         && this._logotypeRect)
        //     {
        //         const logotypeTranslateY = this.$root.width > this.$root.breakpoints.sm ? this.$root.height - (this._logotypeRect.height / 2) : (this.$root.height - this._newsTitleRect.height / 2) - (this._logotypeRect.height / 2)
        //         const logotypeScale = this.$root.width > this.$root.breakpoints.sm ? 2 / 5 : 5 / 7
        //
        //         this.$logotype.style.transform = `translateY(${logotypeTranslateY}px) scale(${logotypeScale}) translateZ(0)`
        //     }
        // },

        _showSectionFilters()
        {
            this.eventHub.$emit('app-header:hide-header')
            this.sectionFiltersIsVisible = true

            this.eventHub.$emit('page:disable-scroll')
        },

        _hideSectionsFilters()
        {
            this.eventHub.$emit('app-header:show-filter')
            this.eventHub.$emit('app-header:show-header')
            this.sectionFiltersIsVisible = false

            this.eventHub.$emit('page:enable-scroll')
        },

        _getCases(category)
        {
            this.cases.length = 0
            this.cases = []

            this.activeCasesID = []
            this.activeCasesID.length = 0

            if (category === 'all')
            {
                this.cases = this.$root.content.cases.entries.filter(c => c.is_published)
            }
            else if (category)
            {
                this.cases = this.$root.content.cases.entries.filter(c => c.is_published).filter(c => c.category && category === c.category.title_slug)
            }
            else
            {
                this.cases = this.$root.content.cases.entries.filter(c => c.is_published).filter(c => c.is_featured)
            }

            this.NB_SECTION = this.cases.length > 0 ? 3 : 2
        },

        _refreshNewFilters(category)
        {
            this.$root.scrollTo(0, true)
            this._getCases(category)

            this.$nextTick(() =>
            {
                this._getDOMElements()

                this._onResize()
                this._hideSectionsFilters()

                this._refreshVideos()
            })
        },

        _refreshVideos()
        {
            this.videosCanBePlayed = []
            this.videosCanBePlayed.length = 0

            this._loadVideos()
            this._loadImages()
        },

        _playActiveCasesVideos()
        {
            if (this.$casesVideos.length > 0
                && !this.$root.isTouch)
            {
                for (let i = 0; i < this.$casesVideos.length; i += 1)
                {
                    const video = this.$casesVideos[i]

                    if (this.videosCanBePlayed.indexOf(i) !== -1)
                    {
                        if (this.activeCasesID.indexOf(i) !== -1)
                        {
                            video.play()
                        }
                        else if (!video.paused)
                        {
                            video.pause()
                        }
                    }
                }
            }
        },

        // SCROLL
        _changeSectionIDTo(index)
        {
            if (this.isAnimated || this.$root.scrollIsDisabled) return
            this.isAnimated = true

            this.activeSectionID = index

            if (this.$root.homeLastSectionScrollTop <= 5) this.$root.scrollTo(this.$root.height * this.activeSectionID, true)

            setTimeout(() =>
            {
                this.isAnimated = false
            }, 1000 /* transition-duration for the sections */)
        },

        _onPreviousSection()
        {
            this._changeSectionIDTo(clamp(this.activeSectionID - 1, 0, this.NB_SECTION - 1))
        },

        _onNextSection()
        {
            this._changeSectionIDTo(clamp(this.activeSectionID + 1, 0, this.NB_SECTION - 1))
        },

        onMouseWheel(event)
        {
            if (this.activeSectionID === 2
                && (event.deltaY < 0 || event.detail < 0)
                && this.$root.smoothScroll <= 0
                && !this._goingBackToNews)
            {
                this._goingBackToNews = true
                setTimeout(() =>
                {
                    this._goingBackToNews = false
                }, 1000)

                this._onPreviousSection()
            }

            if (this.activeSectionID === 2 || this._goingBackToNews) return

            event.preventDefault()
            event.stopPropagation()

            clearTimeout(this.wheelTimer)
            this.wheelTimer = setTimeout(() =>
            {
                this._isWheeling = false
            }, 100)


            if (Math.abs(-this.normalizeWheel(event).pixelY) < 20)
            {
                clearTimeout(this.wheelTimer)
                this._isWheeling = false
            }

            if (this._isWheeling
                || Math.abs(-this.normalizeWheel(event).pixelY) < 20
                || Date.now() - this._lastWheelTime < 750)
            {
                return
            }

            this._lastWheelTime = Date.now()

            this._wheelEndTimer = setTimeout(() =>
            {
                clearTimeout(this.wheelTimer)
                this._isWheeling = false
            }, 1000)

            this._isWheeling = true

            this._isScrollFromWheel = true

            const normalizeWheel = this.normalizeWheel(event)
            const wheelDeltaY = -normalizeWheel.pixelY
            const delta = wheelDeltaY

            if (delta < 0)
            {
                this._onNextSection()
            }
            else if (delta > 0)
            {
                this._onPreviousSection()
            }
        },

        onTouchDown(event)
        {
            if (this._goingBackToNews) return

            this._isPointerDown = true

            this._pointerStartX = event.touches[0].clientX
            this._pointerStartY = event.touches[0].clientY

            this._pointerX = this._pointerStartX
            this._pointerY = this._pointerStartY
        },

        onTouchMove(event)
        {
            if (this._goingBackToNews) return

            if (!this._isPointerDown) return

            if (this.activeSectionID !== 2) event.preventDefault()

            this._pointerX = event.touches[0].clientX
            this._pointerY = event.touches[0].clientY
        },

        onTouchEnd(/* event */)
        {
            if (this.activeSectionID === 2
                && this._pointerY > this._pointerStartY
                && this.$root.smoothScroll <= 0
                && !this._goingBackToNews)
            {
                this._goingBackToNews = true
                setTimeout(() =>
                {
                    this._goingBackToNews = false
                }, 1000)

                this._onPreviousSection()
            }

            if (this.activeSectionID === 2 || this._goingBackToNews) return

            if (!this._isPointerDown) return

            this._isPointerDown = false

            if (Math.abs(this._pointerStartY - this._pointerY) > 10)
            {
                if (this._pointerY > this._pointerStartY)
                {
                    this._onPreviousSection()
                }
                else
                {
                    this._onNextSection()
                }
            }
        },

        normalizeWheel(event)
        {
            this._sX = 0
            this._sY = 0 // spinX, spinY

            this._pX = 0
            this._pY = 0 // pixelX, pixelY

            // Legacy
            if ('detail' in event)
            {
                this._sY = event.detail
            }
            if ('wheelDelta' in event)
            {
                this._sY = -event.wheelDelta / 120
            }
            if ('wheelDeltaY' in event)
            {
                this._sY = -event.wheelDeltaY / 120
            }
            if ('wheelDeltaX' in event)
            {
                this._sX = -event.wheelDeltaX / 120
            }

            // side scrolling on FF with DOMMouseScroll
            if ('axis' in event && event.axis === event.HORIZONTAL_AXIS)
            {
                this._sX = this._sY
                this._sY = 0
            }

            this._pX = this._sX * this.PIXEL_STEP
            this._pY = this._sY * this.PIXEL_STEP

            if ('deltaY' in event)
            {
                this._pY = event.deltaY
            }
            if ('deltaX' in event)
            {
                this._pX = event.deltaX
            }

            if ((this._pX || this._pY) && event.deltaMode)
            {
                if (event.deltaMode == 1)
                {          // delta in LINE units
                    this._pX *= this.LINE_HEIGHT
                    this._pY *= this.LINE_HEIGHT
                }
                else
                {                             // delta in PAGE units
                    this._pX *= this.PAGE_HEIGHT
                    this._pY *= this.PAGE_HEIGHT
                }
            }

            // Fall-back if spin cannot be determined
            if (this._pX && !this._sX)
            {
                this._sX = (this._pX < 1) ? -1 : 1
            }

            if (this._pY && !this._sY)
            {
                this._sY = (this._pY < 1) ? -1 : 1
            }

            return { spinX: this._sX,
                spinY: this._sY,
                pixelX: this._pX,
                pixelY: this._pY }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-home/script.js